const searchStrip = {
  hotels: "호텔", // translated 
  city: "도시", // translated 
  checkIn: "체크인", // translated 
  checkOut: "체크아웃", // translated 
  date: "날짜", // translated 
  persons: "명", // translated 
  adults: "성인", // translated 
  rooms: "객실", // translated 
  editSearch: "검색 수정", // translated 
  newSearch: "새로운 검색", // translated 
  listView: "목록 보기", // translated 
  mapView: "지도 보기", // translated 
};


export default searchStrip;
